import { useRef } from "react";
import "./style/header.css";
import CTA from "./CTA";
import ME from "../assets/me5.png";
import HeaderSocials from "./HeaderSocials";
import Typewriter from "typewriter-effect";

function Header() {
  const titleRef = useRef();

  return (
    <header className="box1">
      <div className="container header__container">
        <h5 ref={titleRef}>
          <span className="text">H</span>
          <span className="text">e</span>
          <span className="text">l</span>
          <span className="text">l</span>
          <span className="text">o </span>
          <span className="text">I</span>
          <span className="text">'</span>
          <span className="text">a</span>
          <span className="text">m</span>
        </h5>
        <h1 className="text">
          <Typewriter
            options={{
              autoStart: true,
              loop: true,
              delay: 40,
              strings: ["Felix N'tougan"],
            }}
          />
        </h1>
        <h5 className="text-light text">Frontend Developer(React JS )</h5>
        <CTA />
        <HeaderSocials />
        <div className="me">
          <img src={ME} alt="me" />
        </div>
        <a href="#contact" className="scroll__down">
          Scroll Down
        </a>
      </div>
    </header>
  );
}

export default Header;
